import { render } from "./StickerView.vue?vue&type=template&id=02eaed2f&scoped=true&ts=true"
import script from "./StickerView.vue?vue&type=script&lang=ts"
export * from "./StickerView.vue?vue&type=script&lang=ts"

import "./StickerView.vue?vue&type=style&index=0&id=02eaed2f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02eaed2f"]])

export default __exports__